import { SiaMenu } from '../interfaces/sia-menu';

/**
 * Ordina in-place una lista di SiaMenu usando come chiave primaria il minimo
 * `sidebarOrderIndex` del gruppo (`divisorId`) di appartenenza, e come chiave
 * secondaria il `sidebarOrderIndex` stesso.
 *
 * I menu marcati come `isFavorite` vengono mantenuti in testa, preservando il
 * loro ordine relativo (chiave del gruppo `Number.NEGATIVE_INFINITY`).
 * I menu senza `divisorId` (e non favoriti) sono trattati come "senza gruppo"
 * e ordinati prima di ogni gruppo reale.
 *
 * Restituisce la stessa reference passata in input (ordinamento in-place).
 */
export function sortMenusByGroupMinOrder(menus: SiaMenu[]): SiaMenu[] {
  const groupMinOrder = new Map<string, number>();
  for (const element of menus) {
    if (element.isFavorite || !element.divisorId) continue;
    const order = element.sidebarOrderIndex ?? Number.MAX_SAFE_INTEGER;
    const current = groupMinOrder.get(element.divisorId);
    if (current === undefined || order < current) {
      groupMinOrder.set(element.divisorId, order);
    }
  }
  menus.sort((a, z) => {
    if (a.isFavorite !== z.isFavorite) return a.isFavorite ? -1 : 1;
    if (a.isFavorite) return 0;
    const aKey = a.divisorId ? groupMinOrder.get(a.divisorId)! : Number.NEGATIVE_INFINITY;
    const zKey = z.divisorId ? groupMinOrder.get(z.divisorId)! : Number.NEGATIVE_INFINITY;
    if (aKey !== zKey) return aKey - zKey;
    return (a.sidebarOrderIndex ?? Number.MAX_SAFE_INTEGER) - (z.sidebarOrderIndex ?? Number.MAX_SAFE_INTEGER);
  });
  return menus;
}
